import { createWebErrorReporter, installGlobalErrorHandlers } from '@dcs/platform/errors';
import { PACKAGE as WEB_PLATFORM } from '@dcs/platform/web';
import type { Entitlements, ErrorReporter, Ports } from './ports';

/** Console adapter: development and tests (nothing leaves the machine). */
export const consoleErrorReporter: ErrorReporter = {
  report(error, context) {
    console.error('[client-error]', context?.source ?? 'manual', error, context?.componentStack);
  },
};

let productionReporter: ErrorReporter | undefined;

/**
 * Production adapter (F7 T-2.5): posts scrubbed, deduped errors to `/api/client-errors`
 * (`@dcs/platform/errors`). Built once per page: it also reports uncaught errors and unhandled promise
 * rejections of the window, which the React error boundary never sees.
 */
export function productionErrorReporter(): ErrorReporter {
  if (productionReporter === undefined) {
    const reporter = createWebErrorReporter({ app: 'app' });
    installGlobalErrorHandlers(reporter);
    productionReporter = reporter;
  }
  return productionReporter;
}

/** MVP adapter: every feature is available. */
export const allowAllEntitlements: Entitlements = {
  can: () => true,
};

export interface WebPortsOptions {
  /** Report errors to the API (default: production builds only; dev and tests log to the console). */
  reportErrors?: boolean;
}

/** Ports for the browser. The platform adapter is a placeholder until `@dcs/platform/web` has one. */
export function createWebPorts({
  reportErrors = import.meta.env.PROD,
}: WebPortsOptions = {}): Ports {
  return {
    platform: WEB_PLATFORM,
    errorReporter: reportErrors ? productionErrorReporter() : consoleErrorReporter,
    entitlements: allowAllEntitlements,
  };
}
